import { Fragment } from 'react'
import ComponentHeading from '../../../../widgets/ComponentHeading'
import { FaListUl } from 'react-icons/fa'
import { EditPenBtn, NextBtn, PrevBtn } from '../../../../widgets/AppBtn'

const EnthinicityMappingListView = ({ onAcaListData, fetchAcademicsListView, setOnEditID }) => {
    return (
        <Fragment>
            <div className='bg-white rounded-md p-4 shadow-sm dark:bg-slate800'>
                <ComponentHeading icon={FaListUl} label={"Enthinicity Mapping List"} />
                <div className="relative overflow-x-auto">
                    <table className="text-sm text-left rtl:text-right text-gray-100 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                        <thead className="text-[12px] text-gray700 bg-gray300  capitalize border-b dark:bg-slate900 dark:text-gray-400 font-public-sans">
                            <tr>
                                <th scope="col" align='center' className="px-2 py-1 border dark:border-slate600 w-10">
                                    {"S.N."}
                                </th>
                                <th scope="col" className="px-2 py-1 border dark:border-slate600">
                                    {"Caste Name"}
                                </th>
                                <th scope="col" className="px-2 py-1 border dark:border-slate600">
                                    {"Caste Name(Nepali)"}
                                </th>
                                <th scope="col" className="px-2 py-1 border dark:border-slate600">
                                    {"Ethnicity Name"}
                                </th>
                                <th scope="col" align='center' className="px-2 py-1 border dark:border-slate600">
                                    {"Action "}
                                </th>
                            </tr>
                        </thead>
                        <tbody className='text-slate-800'>
                            {Array.isArray(onAcaListData?.results) &&
                                onAcaListData?.results?.map((cls, index) => (
                                    <tr key={index} className="odd:bg-white text-[12px] text-gray-800 dark:text-gray-400 odd:dark:bg-slate800 even:bg-gray-50 even:dark:bg-slate700 border-b font-public-sans dark:border-gray-700">
                                        <td align='center' className="px-2 border dark:border-slate600  ">
                                            {index + 1}.
                                        </td>
                                        <td className="px-2 border dark:border-slate600 capitalize">
                                            {cls?.caste_name}
                                        </td>
                                        <td align='left' className="px-2 border dark:border-slate600 ">
                                            {cls?.caste_name_nep}
                                        </td>
                                         <td align='left' className="px-2 border dark:border-slate600 ">
                                            {cls?.ethnicity}
                                        </td>
                                        <td align='center' className="px-2 border dark:border-slate600 ">
                                            <EditPenBtn wh={6} onClick={async () => await setOnEditID(cls?.caste_id)} />
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='flex gap-3 mt-3 justify-end'>
                <PrevBtn disabled={onAcaListData?.previous === null ? true : false} onClick={async () => {
                    if (onAcaListData?.previous) {
                        await fetchAcademicsListView(onAcaListData?.previous)
                    }
                }} />
                <NextBtn disabled={onAcaListData?.next === null ? true : false} onClick={async () => {
                    if (onAcaListData?.next) {
                        await fetchAcademicsListView(onAcaListData?.next)
                    }
                }} />
            </div>
        </Fragment>
    )
}

export default EnthinicityMappingListView